// SECURITY NOTE: Client-side permission checks are UI-only (UX improvement).
// The backend validates ALL permissions on every request — these checks
// only prevent rendering unauthorized UI elements, not actual data access.
import { Navigate, Outlet } from 'react-router-dom'
import { FullPageSpinner } from '@/components/ui/loading-spinner'
import { usePermissions } from '@/hooks/use-permissions'
import type { PermissionKey } from '@/types/permission'

interface PermissionRouteProps {
  permission: PermissionKey
}

export function PermissionRoute({ permission }: PermissionRouteProps) {
  const { hasPermission, isLoading } = usePermissions()

  if (isLoading) {
    return <FullPageSpinner minHeight='min-h-[50vh]' />
  }

  if (!hasPermission(permission)) {
    return <Navigate to='/403' replace />
  }

  return <Outlet />
}
